import { OAuthProvider, signInWithRedirect } from "firebase/auth"

import { firebaseAuth } from "@plugins/session/auth/firebase"

export function handleMicrosoftSignIn() {
    let redirectPath = window.location.pathname || "/"
    if (!redirectPath.startsWith("/")) {
        redirectPath = "/" + redirectPath
    }

    const provider = new OAuthProvider("microsoft.com")
    provider.addScope("profile")
    provider.addScope("email")
    signInWithRedirect(firebaseAuth, provider)
}
